export const SHOW_TOAST = "SHOW_TOAST";
export const HIDE_TOAST = "HIDE_TOAST";

export const showToast = (message, severity = "success") => ({
  type: SHOW_TOAST,
  payload: { message, severity },
});

export const hideToast = () => ({
  type: HIDE_TOAST,
});